import CreateMarketingPromotion from './CreateMarketingPromotion.container';

export default CreateMarketingPromotion;
